import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/invitacion/:id",
    name: "Reference",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/StaticTest.vue"),
  },
  {
    path: "/payments",
    name: "Payments",
    component: () => import("../views/Payments.vue"),
  },
  {
    path: "/:param0",
    name: "",
    component: () => import("../views/Viewer.vue"),
    children: [],
  } /* ,
  {
    path: "/:param0",
    name: "",
    component: () => import("../views/Viewer.vue"),
  }, */,
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router
